<template>
  <div>
    <!-- <div class="tabs">
      <ul>
        <li :class="{ 'is-active': tab === 'project-dashboard'}"><a @click="tab='project-dashboard'">Ärendeöversikt</a></li>
        <li :class="{ 'is-active': tab === 'metrics'}"><a @click="tab='metrics'">Onflow Överblick</a></li>
      </ul>
    </div> -->
    <default-dashboard v-if="tab === 'default-dashboard'"></default-dashboard>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import DefaultDashboard from './StaffViews/DefaultDashboard.vue'
import Metrics from './StaffViews/Metrics.vue'

export default {
  components: {
    DefaultDashboard,
    Metrics
  },

  data () {
    return {
      // tab: 'cash-settlement',
      tab: 'default-dashboard',
      roles: null,
      permissions: null,
      tableMetrics: null,
      userRoles: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    ...mapGetters('auth', ['hasPermission'])
  },

  methods: {
    ...mapActions('meta', ['getRoles', 'getPermissions', 'getDatabaseTableMetrics', 'getUserRoleMetrics'])

    // hasPermission (permission) {
    //   return this.user.permissions.includes(permission)
    // }
  },

  created () {
    this.getRoles().then(roles => {
      this.roles = roles.result
    })

    this.getPermissions().then(permissions => {
      this.permissions = permissions
    })

    this.getDatabaseTableMetrics().then(tableMetrics => {
      this.tableMetrics = tableMetrics
    })

    this.getUserRoleMetrics().then(userRoles => {
      this.userRoles = userRoles
      console.log('userRoles')
      console.log(userRoles)
      console.log('userRoles')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Dashboard/DashboardStaff.vue